<template>
    <div
        class="notification"
        :class="position"
    >
        <b-alert
            :show="show"
            :variant="variant"
            @dismissed="time=0"
        >
            <p class="m-0">{{ message }}</p>
        </b-alert>
    </div>
</template>

<script>
export default {
    name: "Notification",
    props: ["message", "variant", "position"],
    data() {
        return {
            time: 0,
            show: false,
            timeout: null
        };
    },
    watch: {
        time: function () {
            var _this = this;
            if (_this.time > 0) {
                _this.show = true;
                _this.timeout = setTimeout(function () {
                    _this.dismiss();
                }, _this.time);
            } else {
                _this.dismiss();
            }
        }
    },
    methods: {
        dismiss() {
            this.show = false;
            this.time = 0;
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
        }
    }
};
</script>

<style scoped>
.notification {
    position: fixed;
    z-index: 9999999;
}

.notification.bottom-right {
    bottom: 2rem;
    right: 2rem;
}

.notification .alert-success p {
    color: var(--blu-rikorda);
}
</style>
